import { ticketActions as A, getDefaultStats } from "./reducer";
import { numberWithCommas, removeParentheses, formatDate } from "../../helpers/formatters";
import { cardTypes, cardStatuses, userPermissions } from "../../config";
import { ratio } from "../../helpers/ratios";
import liveticketsclient from "../../helpers/liveticketsclient";
import moment from 'moment';

/** Actions */
export function connectLiveTickets() {
    return (dispatch, getState) => {
        const { tickets, user } = getState();

        if (!user.permissions.includes(userPermissions.viewBookings)) {
            return dispatch(_disconnectedLiveTickets());
        }

        // if live tickets are already connected don't attempt to reconnect
        if (tickets.connected_live_tickets || tickets.connecting_live_tickets) {
            return;// console.info('Live tickets already connected or connecting');
        }
        dispatch(_connectingLiveTickets());
        liveticketsclient.connect(
            () => {
		setTimeout(() => {
			dispatch(_connectedLiveTickets());
		}, 1000)
                liveticketsclient.on("new_ticket", (ticket) => {
                    console.log("Incoming Ticket: ", ticket);
                    dispatch(pushLiveTicket(Object.assign({}, ticket)));
                })
            },
            () => { dispatch(_disconnectedLiveTickets()) },
            () => { dispatch(_errorLiveTickets()) }
        );
    }
}

export function disconnectLiveTickets() {
    return (dispatch, getState) => {
        const { tickets } = getState();

        // do nothing if we're already disconnected from live tickets
        if (tickets.disconnected_live_tickets) {
            return;
        }

        liveticketsclient.disconnect();
        dispatch(_disconnectedLiveTickets());
    }
}

export function pushLiveTicket(ticket) {
    return (dispatch, getState) => {
        let ticketsStore = getState().tickets;
        let searchStore = getState().search;

        let tickets = Object.assign([], ticketsStore.tickets);
        let stats = Object.assign({}, ticketsStore.stats);
        let highlighted_tickets = Object.assign([], ticketsStore.highlighted_tickets);

        // add to the top of array
        tickets.unshift(ticket);

        // remove one ticket from bottom if tickets are on max length
        if (tickets.length > searchStore.paginationOptions.per_page) {
            // remove last item in array
            tickets.splice(-1, 1);
        }

        // convert to set to add unique items only
        // let htickets = new Set(highlighted_tickets)
        // htickets.add(ticket.CardID);
        // htickets = Array.from(htickets);
        highlighted_tickets.push(String(ticket.CardID));
        let htickets = highlighted_tickets;

        ticket.CardTotalPrice = Number(ticket.CardTotalPrice);

        // add new ticket data to stats
        stats.all_total += ticket.CardTotalPrice;
        ++stats.all_count;

        if (ticket.CardStatusID === cardStatuses.paid) {
            // paid ticket
            if (ticket.CardTypeID === cardTypes.cc) {
                // credit card
                stats.cc.total += ticket.CardTotalPrice;
                stats.cc.paid.total += ticket.CardTotalPrice;
                ++stats.cc.paid.count;
            } else if (ticket.CardTypeID === cardTypes.cash) {
                // cash
                stats.cash.total += ticket.CardTotalPrice;
                stats.cash.paid.total += ticket.CardTotalPrice;
                ++stats.cash.paid.count;
            }

        } else if (ticket.CardStatusID === cardStatuses.pending) {
            // pending ticket (only cash cards can be in pending state)
            stats.cash.total += ticket.CardTotalPrice;
            stats.cash.pending.total += ticket.CardTotalPrice;
            ++stats.cash.pending.count;
        }

        const total_accepted_base = stats.cc.paid.total + stats.cash.paid.total;
        const all_totals_base = stats.cc.total + stats.cash.total;

        let acceptedCCRatio = ratio(stats.cc.paid.total, total_accepted_base);
        let acceptedCashRatio = ratio(stats.cash.paid.total, total_accepted_base);

        let allCCRatio = ratio(stats.cc.total, all_totals_base);
        let allCashRatio = ratio(stats.cash.total, all_totals_base);

        stats.cc.paid.ratio = isNaN(acceptedCCRatio) ? 0 : acceptedCCRatio.toFixed(2);
        stats.cash.paid.ratio = isNaN(acceptedCashRatio) ? 0 : acceptedCashRatio.toFixed(2);

        stats.cc.ratio = isNaN(allCCRatio) ? 0 : allCCRatio.toFixed(2);
        stats.cash.ratio = isNaN(allCashRatio) ? 0 : allCashRatio.toFixed(2);

        // update tickets
        dispatch(_setTickets({
            tickets,
            total_pages: ticketsStore.total_pages
        }));

        // update highlighted tickets
        dispatch(_updateHighlighted({
            highlighted_tickets: htickets,
        }));

        // update stats
        dispatch(_updateStats(stats));
    }
}

export function shouldUnhighlightTicket(CardID) {
    return (dispatch, getState) => {
        let htickets = getState().tickets.highlighted_tickets;

        let idx = htickets.indexOf(String(CardID));

        if (idx !== -1) {
            htickets.splice(idx, 1);

            dispatch(_updateHighlighted({
                highlighted_tickets: htickets
            }));
        }
    }
}

/** Dispatchers */
function _errorLiveTickets(error) {
    return {
        type: A.error_live_tickets,
        data: error
    }
}

function _connectedLiveTickets() {
    return {
        type: A.connected_live_tickets
    }
}

function _disconnectedLiveTickets() {
    return {
        type: A.disconnected_live_tickets
    }
}

function _connectingLiveTickets() {
    return {
        type: A.connecting_live_tickets
    }
}

export function _setTickets({ tickets, total_pages }) {

    // data formatting loop
    if (Array.isArray(tickets)) {
        tickets.forEach($ticketFormatter)
    }

    const data = {
        tickets,
        total_pages
    };

    return {
        type: A.set_tickets,
        data
    }
}

export function _updateHighlighted({ highlighted_tickets }) {
    return {
        type: A.update_highlighted,
        data: highlighted_tickets
    }
}

export function _updateStats(stats) {
    return {
        type: A.update_stats,
        data: stats
    }
}
// data is passed through _getStats() in search actions file
export function _setStats(data) {

    let stats = Object.assign({}, getDefaultStats());

    data.forEach(bookingType => {
        // credit card and paid
        if (bookingType._id.CardTypeID === cardTypes.cc && bookingType._id.CardStatusID === cardStatuses.paid) {
            stats.cc.paid.count = bookingType.count;
            stats.cc.paid.total = bookingType.total;
            stats.cc.paid.seats = bookingType.seats;
        } else
            // credit card and cancelled
            if (bookingType._id.CardTypeID === cardTypes.cc && bookingType._id.CardStatusID === cardStatuses.cancelled) {
                stats.cc.cancelled.count = bookingType.count;
                stats.cc.cancelled.total = bookingType.total;
                console.log('Canceled Credit count:',stats.cc.cancelled.count);
            } else
                // cash and paid
                if (bookingType._id.CardTypeID === cardTypes.cash && bookingType._id.CardStatusID === cardStatuses.paid) {
                    stats.cash.paid.count = bookingType.count;
                    stats.cash.paid.total = bookingType.total;
                    stats.cash.paid.seats = bookingType.seats;
                } else
                    // cash and pending
                    if (bookingType._id.CardTypeID === cardTypes.cash && bookingType._id.CardStatusID === cardStatuses.pending) {
                        stats.cash.pending.count = bookingType.count;
                        stats.cash.pending.total = bookingType.total;
                    }
                    //cash and canceled [TODO]
                    if (bookingType._id.CardTypeID === cardTypes.cash && bookingType._id.CardStatusID === cardStatuses.cancelled){
                        stats.cash.cancelled.count = bookingType.count;
                        stats.cash.cancelled.total = bookingType.total;
                        console.log('Canceled Cash count:',stats.cash.cancelled.count);
                    }
    });

    // total paid cards prices [Net Revenue]
    stats.paid_total = stats.cc.paid.total + stats.cash.paid.total;

    // count of paid cards [Net Revenue]
    stats.paid_count = stats.cc.paid.count + stats.cash.paid.count;

    // total paid seats number [Net Revenue]
    stats.paid_seats = stats.cc.paid.seats + stats.cash.paid.seats;

    // total pending prices [ex: Fawry/Aman]
    stats.pending_total = stats.cash.pending.total;

    // total pending counts [ex: Fawry/Aman]
    stats.pending_count = stats.cash.pending.count;

    // total cancelled cards prices [Credit + Cash]
    stats.cancelled_total = stats.cc.cancelled.total + stats.cash.cancelled.total;
    
    // count of cancelled cards [Credit + Cash]
    stats.cancelled_count = stats.cc.cancelled.count + stats.cash.cancelled.count;

    // total of paid and cancelled
    stats.all_total = Math.floor(stats.paid_total + stats.cancelled_total + stats.pending_total);

    // count of paid and cancelled
    stats.all_count = stats.paid_count + stats.cancelled_count + stats.pending_count;

    // total of credit card paid and cancelled
    stats.cc.total = Math.floor(stats.cc.paid.total + stats.cc.cancelled.total);

    // total of cash paid and pending (& canceled) 
    stats.cash.total = Math.floor(stats.cash.paid.total + stats.cash.pending.total + stats.cash.cancelled.total);

    /** Ratios */
    const total_accepted_base = stats.cc.paid.total + stats.cash.paid.total;
    const total_cancelled_base = stats.cc.cancelled.total + stats.cash.cancelled.total;
    const all_totals_base = stats.cc.total + stats.cash.total;

    let acceptedCCRatio = ratio(stats.cc.paid.total, total_accepted_base);
    let acceptedCashRatio = ratio(stats.cash.paid.total, total_accepted_base);

    let cancelledCCRatio = ratio(stats.cc.cancelled.total, total_cancelled_base);
    let cancelledCashRatio = ratio(stats.cash.cancelled.total, total_cancelled_base);

    let allCCRatio = ratio(stats.cc.total, all_totals_base);
    let allCashRatio = ratio(stats.cash.total, all_totals_base);

    stats.cc.paid.ratio = isNaN(acceptedCCRatio) ? 0 : acceptedCCRatio.toFixed(2);
    stats.cash.paid.ratio = isNaN(acceptedCashRatio) ? 0 : acceptedCashRatio.toFixed(2);

    stats.cc.cancelled.ratio = isNaN(cancelledCCRatio) ? 0 : cancelledCCRatio.toFixed(2);
    stats.cash.cancelled.ratio = isNaN(cancelledCashRatio)? 0 : cancelledCashRatio.toFixed(2);

    stats.cc.ratio = isNaN(allCCRatio) ? 0 : allCCRatio.toFixed(2);
    stats.cash.ratio = isNaN(allCashRatio) ? 0 : allCashRatio.toFixed(2);

    return {
        type: A.set_stats,
        data: stats
    }
}

//function to set chart data requested from backend 
export function _setChart(chartData){

    const clonedChart = chartData.map(v => ({...v}));
    //sorting data
    let sortedData = clonedChart.sort((a, b) => (a.date > b.date) ? 1 : -1);

    sortedData.forEach(element => {
        //reformat date
        element.date = moment(element.date).format("DD MMM")
        
    })
    
    return {
        type: A.set_chart,
        data: sortedData
    }
}

function $ticketFormatter(ticket) {
    ticket.CardTotalPrice = numberWithCommas(ticket.CardTotalPrice);
    ticket.ActionDate = formatDate(ticket.ActionDate);
    ticket.myTrips = ticket.myTrips.map(trip => {
        trip.TripOfficeFrom = removeParentheses(trip.TripOfficeFrom_NameE || '');
        trip.TripOfficeTo = removeParentheses(trip.TripOfficeTo_NameE || '');
        trip.TripDateTime = formatDate(trip.TripDateTime);
        return trip;
    });
}
